export default {
  loadingFirstMessage: 'Einen Moment bitte, der Designer lädt...',
  checking: 'Überprüfen...',
  cash: 'Einlösen',
  toLogin: 'Anmelden',
  payoff: 'Jedes Kind verdient eine Geschichte',
  login: 'Anmelden',
  loginForgot: 'vergessen',
  loginIntro: 'Hier kannst du ein Konto erstellen. Falls du bereits eines hast, melde dich weiter unten direkt an.',
  loginFailed: 'Anmeldung fehlgeschlagen',
  loginNoAccount: 'Ich habe noch kein Konto',
  loginSendNew: 'Neues Passwort anfordern',
  accountCreate: 'Konto erstellen',
  accountAlready: 'Schon ein Konto? Hier anmelden',
  voucherPersonalCode: 'Ich habe einen persönlichen Code',
  voucherIntro: 'Gib deinen persönlichen Code ein. Du findest den Code in der Bestätigungsmail.',
  voucherInvalid:
    'Gib einen gültigen Code mit 15 Zeichen ein, einschließlich der Bindestriche. Zum Beispiel 2Wpa-SFtB-999c.',
  backToLogin: 'Zurück zum Anmeldeschirm',
  passwordRequest: 'Neues Passwort anfordern',
  passwordRequestSend: 'Eine E-Mail mit weiteren Anweisungen wurde versendet.',
  passwordRequestRemember: 'Ist dir dein Passwort wieder eingefallen?',
  childIntro:
    'Gib zuerst den Namen und das Geburtsdatum deines Kindes ein. Sie werden bereits auf einigen Seiten für dich eingefügt.',
  menuAccount: 'Konto',
  menuOrder: 'Bestellen',
  menuChild: 'Kind',
  menuDesigns: 'Designs',
  menuPhotos: 'Bearbeiten',
  menuHelp: 'Hilfe',
  photosChooseMore: 'Weitere Fotos auswählen',
  photosChoose: 'Fotos auswählen',
  assignmentSelectPhotosFirst: 'Lies zuerst deine Fotos ein',
  assignmentSelectPhotos: 'Fotos einlesen',
  assignmentClose: 'Zurück',
  notificationReady: 'Hurra! du bist fertig. Kontrolliere bitte alle Texte und Fotos noch einmal gründlich.',
  notificationGoToOrder: 'Zur Bestellung',
  orderUnfinishedFirstPart:
    'Du kannst noch nicht bestellen. Füge erst überall Fotos und Texte hinzu. Wenn du noch ein gelbes Symbol siehst, fehlt noch etwas. Wenn alle Symbole grün sind, überprüfe noch einmal alles.',
  orderUnfinishedSecondPart: 'Viel Spaß',
  orderIntro: 'Gib die Adresse ein, an die wir dein Fotoalbum senden sollen.',

  kidSectionTtitle: 'Kind',
  childBookTargetInput: 'Dieses Fotoalbum ist für:',
  childBookStartButtonOption1: 'Füge ein Kind hinzu',
  childBookStartButtonOption2: 'Ein weiteres Kind hinzufügen',
  childBookTargetOption1: 'Für wen möchtest du das Fotoalbum gestalten:',
  childBookTargetOption2: 'Oder erstelle es für ein anderes Kind:',
  childFormInputNameLabel: 'Vorname',
  childFormInputNamePlaceholder: 'Vorname deines Kindes',
  childFormInputLettersInformation: 'Du kannst maximal 12 Zeichen eingeben.',
  childFormInputDateLabel: 'Geburtsdatum',
  backButton: 'Zurück',
  getStartedButton: "Los geht's",

  cameraRollTab: 'Meine Fotos',
  pinupTab: 'Pinnwand',
  savedPhotosInformation: 'Gespeicherte Fotos, die bei anderen Aufgaben verwendet werden können',

  designInformations: 'Probier die Designs aus. Deine Arbeit geht nicht verloren.',

  photoDoesntUploadAlert:
    'Ein Foto wurde nicht hochgeladen, weil es zu groß ist (maximal 60 MB) oder nicht im JPG-Format vorliegt.',
  photoDoesntUploadAlertPlural:
    'Es wurden {rejectedFiles} Fotos nicht hochgeladen, weil sie zu groß sind (maximal 60 MB) oder nicht im JPG-Format vorliegen.',
  callToUseThePhotos: 'Lasse los, um deine Fotos zu verwenden',

  personalGiftCodeLabel: 'Persönlicher Code',
  cachedVoucherTitle: 'Code einlösen',

  loginCredentialsTitle: 'Anmelden',
  loginEmailInputLabel: 'E-Mail-Adresse',
  loginErrorMessage: 'Du kannst dich nicht mit einem Administrator-Konto anmelden',
  loginPasswordInput: 'Passwort',
  forgotPasswordSectionTitle: 'Passwort vergessen',
  forgotPasswordEmailPlaceholder: 'Gib deine E-Mail-Adresse ein',
  makeAccountTitleStep1: 'Konto erstellen (1/2)',
  signupFirstNameInputLabel: 'Vorname',
  signupFirstNamePlaceholder: 'Gib deinen Vornamen ein',
  signupEmailInputLabel: 'E-Mail-Adresse',
  signupPasswordInputLabel: 'Passwort',
  acceptPrivacyStatementFirstPart: 'Ich stimme den ',
  acceptPrivacyStatementSecondPart: 'Allgemeinen Geschäftsbedingungen und Datenschutzerklärung zu.',

  smallScreensMessage1: 'Leider ist Kroost noch nicht für Mobilgeräte oder kleinere Geräte verfügbar.',
  smallScreensMessage2:
    'Bist du auf deinem Laptop oder Desktop? Mach den Bildschirm deines Browsers so groß wie möglich.',

  rotate: 'Drehen',
  mirror: 'Spiegeln',
  zoomIn: 'Vergrößern',
  zoomOut: 'Verkleinern',

  warningToAdjustPhotoPart1: 'Um eine gute Druckqualität zu erzielen, musst du dieses Foto anpassen.',
  warningToAdjustPhotoPart2: 'Was kann ich tun?',

  logout: 'Abmelden',
  account: 'Konto',
  loading: 'Wird geladen...',
  openNewBook: 'Ein neues Buch öffnen',

  logout2: 'Abmelden',

  notReadyMessagePart1: 'Bevor du bestellen kannst, musst du ',
  notReadyMessagePart2: 'ein Konto erstellen',
  notReadyMessagePart3: ', damit wir die Fotos verarbeiten können',
  uploadingPhotosMessage: 'Noch nicht alle Fotos wurden hochgeladen',
  loading2: 'Alben werden geladen...',
  backToPay: 'Zurück zur Bezahlung',
  surname: 'Nachname',
  street: 'Straße',
  houseNumber: 'Hausnummer',
  postCode: 'Postleitzahl',
  city: 'Wohnort',
  country: 'Land',
  phone: 'Telefonnummer',
  amount: 'Menge',
  warningMessageBeforeForNoChanges: 'Du kannst diese Bestellung nicht mehr ändern',
  fillTheFieldsMessage: 'Bitte fülle die rot markierten Pflichtfelder aus.',
  checking2: 'Überprüfung...',
  orderComplete: 'Bestellung abschicken',
  orderTitle: 'Bestellen',

  preferdName: ' Vorname',
  dateOfBirth: 'Geboren am (voraussichtlich)',
  makeYourBook: 'Gestalte dein Buch',

  failedUploadWarning:
    'Beim Hochladen der Fotos ist leider ein Fehler aufgetreten. Wenn dies weiterhin passiert, kontaktiere uns bitte.',
  uploandingFaliedMessage: 'Das Hochladen von {fileName} ist fehlgeschlagen',
  feedbackUploadingMessage: '{fileName} wird hochgeladen',
  uploadSuccessMessage: '{fileName} wurde hochgeladen',

  usedPhotoMessageSingular: 'Dieses Foto wurde auf 1 Seite verwendet',
  usedPhotoMessagePlural: 'Dieses Foto wurde auf {count} Seiten verwendet',

  newPasswordLabel: 'Neues Passwort',
  newPasswordPlaceholder: 'Dein neues Passwort',
  formErrorMessage: ' Das Zurücksetzen ist fehlgeschlagen, der Link ist nur 24 Stunden gültig. Fordere ihn erneut an.',
  passwordButtonSubmit: 'Passwort ändern',

  saveSuccessTitle: 'Konto erstellen (2/2)',
  enterTheNameOfChildButton: 'Trage den Namen deines Kindes ein',
  saveSuccessMessagePart1:
    'Dein Konto wurde erstellt. Alle Änderungen, die du in deinem Fotoalbum vornimmst, werden automatisch sofort gespeichert.',
  saveSuccessMessagePart2: 'Viel Spaß!',
  netherlands: 'Niederlande',
  belgium: 'Belgien',
  germany: 'Deutschland',
  austria: 'Österreich',
  paymentWaitingMessage:
    'Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Gehe zurück zur Zahlung, um erneut zu bezahlen.',
  paymentFailedMessage:
    'Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Gehe zurück zur Zahlung, um erneut zu bezahlen.',
  paymentSuccessMessagePart1:
    'Vielen Dank für deine Bestellung - wir machen uns sofort an die Arbeit! Unsere Bestellbestätigung findest du in deinem E-Mail-Postfach. Noch ein wenig Geduld, und schon bald hältst du dein neues Fotoalbum in den Händen!',
  greetins: 'Fröhliche Grüße,',
  teamKroost: 'dein Kroost-Team',
  shippingSendMessagePart1:
    'Deine Bestellung wird innerhalb von 10 Tagen geliefert. Noch ein bisschen warten und dann kann der Genuss beginnen!',
  shippingReceivedMessage: '  Deine Bestellung wurde zugestellt. Viel Spaß damit!',
  mergingPhotos: '{mergedPhotos} von den {photos} fotos eingelesen',
  doneNotificationMessage: '{mergedPhotos} Fotos eingelesen',
  notUsedPhotosMessage: ' - {notused} ignoriert',
  year: 'Jahr',
  months: 'Monat',
  monthsPlural: 'Monate',
  day: 'Tag',
  days: 'Tage',
  week: 'Woche',
  weekPlural: 'Wochen',
  birthday: 'Geburtstag!',
};



// WEBPACK FOOTER //
// ./app/languages/de.js